import { useSelector } from 'react-redux'
import { authenticatedSelector } from '@redux/slices/connectorSlice'
import { customerFacingClaimRecordStatusSelector } from '@redux/slices/claimStatusSlice'
import { CustomerFacingClaimRecordStatus } from '@typesApp/ClaimRecord'

type UseInterceptPromptResult = () => boolean

const CLAIM_STATUS_LIST = [
  CustomerFacingClaimRecordStatus.ACCEPTED,
  CustomerFacingClaimRecordStatus.TIMEOUT_RETRY,
  CustomerFacingClaimRecordStatus.SERVICE_OFFLINE,
]

export const useInterceptPrompt = (): UseInterceptPromptResult => {
  const isAuthenticated = useSelector(authenticatedSelector)
  const claimStatus = useSelector(customerFacingClaimRecordStatusSelector)

  const shouldPrompt = () => {
    return isAuthenticated && CLAIM_STATUS_LIST.includes(claimStatus)
  }

  return shouldPrompt
}
